import { EMPTY_OBJECT } from '../../../../constants/common'
import { WidgetContentFilesImagesListItem } from '../WidgetContentFilesImagesListItem'
import { WidgetContentFilesList } from '../WidgetContentFilesList'

import { VISIBLE_ITEMS_COUNT } from './WidgetContentFilesImagesList.constants'
import { getImageItemProps } from './WidgetContentFilesImagesList.utils'

import * as styles from './WidgetContentFilesImagesList.module.css'

function WidgetContentFilesImagesList({
  itemsContainerProps: {
    className: itemsContainerClassName = styles.itemsContainer,
    ...itemsContainerProps
  } = EMPTY_OBJECT,
  titleKey = 'Common.ProfileWidgetDocumentsImagesTitleKey',
  visibleCount = VISIBLE_ITEMS_COUNT,
  ...restProps
}) {
  return (
    <WidgetContentFilesList
      {...restProps}
      Item={WidgetContentFilesImagesListItem}
      getItemPropsFromValue={getImageItemProps}
      itemsContainerProps={{
        ...itemsContainerProps,
        className: itemsContainerClassName,
      }}
      titleKey={titleKey}
      visibleCount={visibleCount}
    />
  )
}

export default WidgetContentFilesImagesList
